export default function Machines_B_7 (number = 1) {
  return {
    name: '电磁轨道弹射器',
    icon: '/static/img/machines/b7.png',
    number
  }
}



// WEBPACK FOOTER //
// ./src/components/Machines_B/Machines_B_7.js